import React from 'react';
import Main from '~/templates/Main';
import Button from '~/components/Button';
import Text from '~/components/Text';
import { Translation } from '~/components/Translation';
import styled from 'styled-components';

const Wrap = styled.div`
	width: 100%;
	padding: 8rem 2rem 0;
	text-align: center;
`;

const Heading = styled(Text)`
	font-size: 120px;
`;

export const ErrorContent = () => (
	<Wrap>
		<Heading variant="h1" gutterBottom>
			500
		</Heading>
		<Text variant="h2" gutterBottom>
			<Translation tid="common.500.title" />
		</Text>
		<Button to="/">
			<Translation tid="common.500.goHome" />
		</Button>
	</Wrap>
);

const Error = () => (
	<Main>
		<ErrorContent />
	</Main>
);

export default Error;
